// extracted by mini-css-extract-plugin
export default {"HeaderItem":"DefaultHeader_HeaderItem__eClGL","Header":"DefaultHeader_Header__TL+bU"};